<template>
  <div>
    <strong class="q-mb-md">
      {{ $t("outreach_location_selector.filter_contacts") }}
    </strong>
    <div
      v-for="topLocation in topLocations"
      :key="topLocation.id"
    >
      <Checkbox
        class="small primary"
        :indeterminate="isIndeterminate(topLocation)"
        :label="topLocation.name"
        :model-value="!selectedLocations.includes(topLocation.id)"
        new-design
        @update:model-value="
          $emit('toggle-region', topLocation, {
            value: $event,
            toggleChildren: true,
          })
        "
      />
      <div
        v-if="locationsForParent(topLocation).length > 0"
        class="row q-ml-md"
      >
        <Checkbox
          v-for="location in locationsForParent(topLocation)"
          :key="location.key"
          class="primary col-2"
          :label="location.name"
          :model-value="!selectedLocations.includes(location.id)"
          new-design
          @update:model-value="
            $emit('toggle-country', location, topLocation, $event)
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { sortBy } from "lodash-es";

export default {
  name: "OutreachLocationSelector",
  props: {
    selectedLocations: {
      type: Array,
      required: true,
    },
    locations: {
      type: Array,
      required: true,
    },
  },
  emits: ["toggle-region", "toggle-country"],
  computed: {
    topLocations() {
      const filteredLocations = this.locations.filter(
        (location) =>
          (location.locationType === "Continent" ||
            location.locationType === "Sub-Continent" ||
            location.locationType === "Area of Interest") &&
          location.name !== "CIS"
      );

      return sortBy(filteredLocations, ["name"]);
    },
  },
  methods: {
    isIndeterminate(location) {
      const childLocations = this.locationsForParent(location).map(
        ({ id }) => id
      );

      const selectedLocationIds = this.selectedLocations.filter((id) =>
        childLocations.includes(id)
      );

      return Boolean(
        selectedLocationIds.length &&
          selectedLocationIds.length < childLocations.length
      );
    },
    locationsForParent({ id }) {
      return this.locations.filter(
        (location) =>
          location.parentId === id &&
          location.name !== "Central America" &&
          location.name !== "South America"
      );
    },
  },
};
</script>
